import React from 'react';
import * as ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import $ from 'jquery';

import { scrollToAnchor } from '../common/utilities';
import { GetStartedSection } from './GetStartedSection';

export class Header extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            currentTab: this.props.isCurated() ? 'curatedPath' : 'buildPath',
            countOfHighlightedElements: 0,
            searchValue: '',
        };

        this.onSearch = this.onSearch.bind(this);
        this.pathOptionOnClick = this.pathOptionOnClick.bind(this);
    }

    componentDidMount() {
    }

    onSearch(event) {
        event.persist();

        const { reset } = this.props;

        reset();

        let countOfHighlightedElements = 0;

        if (event.target.value !== '') {
            const searchValue = event.target.value.toLowerCase();

            const decode = (htmlString) => new DOMParser().parseFromString(htmlString, 'text/html').documentElement.textContent;

            const highlightElements = this.props.jobs
                .filter(job => {

                    const isMatchName = decode(job.name.toLowerCase()).includes(searchValue);
                    const isMatchDescription = decode(job.job_description.toLowerCase()).includes(searchValue);

                    return isMatchName || (this.props.includeSearchDescriptions && isMatchDescription);
                })
                .map(job => job.id);

            this.props.mapNode().classList.add('is-active');

            highlightElements.forEach((id) => {
                document.querySelector('.job[data-id="' + id + '"]').classList.add('is-selected');
            });

            countOfHighlightedElements = highlightElements.length;
        }

        this.setState(() => ({
            countOfHighlightedElements,
            searchValue: event.target.value,
        }));
    }

    pathOptionOnClick(event) {
        event.preventDefault();

        const { mapNode, setCurated, reset, showCuratedJobs, isMixpanel, clearMap } = this.props;
        const el = event.currentTarget;

        const pathName = $(el).text() || 'N/A';

        if (isMixpanel) {
            window.mixpanel.track('Tab Click', {
                'Tab Name': pathName
            });
        }

        if (this.state.currentTab !== el.id) {
            let isCurated = (el.id === 'curatedPath');
            let isAboutModal = (el.id === 'aboutModal');

            setCurated(isCurated);

            reset(true);

            if (!el.classList.contains('is-active')) {
                document.querySelectorAll('.path-option').forEach((option) => {
                    option.classList.remove('is-active');
                });

                el.classList.add('is-active');
            }

            if (isCurated) {
                showCuratedJobs();
                mapNode().classList.add('is-curated');
            } else if (isAboutModal) {
                //
            } else {
                mapNode().classList.remove('is-curated');

                clearMap();
            }

            this.setState({
                currentTab: el.id,
                searchValue: '',
            })
        }
    }

    render() {
        const {
            isCurated,
            mapName,
            getTracedJobs,
            curatedJobs,
            reset,
            headline,
            subHeadline,
            aboutThisMap,
            disclaimer,
            disclaimerPosition,
            disclaimerCollegeText,
            disclaimerUnionText,
            isShowRegions,
            regions,
            selectedRegion,
            setRegion,
            enableSemiconductorDisclaimer,
            semiconductorToggleLabel,
            toggleSemiconductorJobs,
            highlightDemandJobs,
            highDemandText,
            isIncludeGetStartedSection,
            getStartedSection,
        } = this.props;

        const { countOfHighlightedElements, searchValue } = this.state;

        const countOfSelectedJobs = getTracedJobs() ? getTracedJobs().length : 0;

        return (
            <>
                <header className="map-header">
                    <h1 className="module-title">{mapName}</h1>

                    {
                        isIncludeGetStartedSection && getStartedSection && (getStartedSection['left_column'] || getStartedSection['right_column']) ? (
                            <GetStartedSection
                                getStartedSection={getStartedSection}
                                isShowRegions={isShowRegions}
                                regions={regions}
                                setRegion={setRegion}
                                labels={this.props.labels}
                            />
                        ) : null
                    }

                    <ul className="path-options">
                        <li>
                            <a
                                href="#"
                                id="buildPath"
                                className={classNames('path-option', {
                                    'is-active': !isCurated()
                                })}
                                onClick={this.pathOptionOnClick}
                            >

                                {this.props.labels?.build_path_btn || 'Build your Path'}
                            </a>
                        </li>
                        <li>
                            <a
                                href="#aboutModal"
                                className={classNames('path-option js-modal')}
                            >
                                {this.props.labels?.about_map_btn || 'About this Map / FAQs'}
                            </a>
                        </li>
                        {
                            curatedJobs.length ? (
                                <li>
                                    <a
                                        href="#"
                                        id="curatedPath"
                                        className={classNames('path-option', {
                                            'is-active': isCurated()
                                        })}
                                        onClick={this.pathOptionOnClick}
                                    >
                                        {this.props.labels?.curated_paths_btn || 'Curated Paths'}
                                    </a>
                                </li>
                            ) : null
                        }
                    </ul>

                    <div className="pre-map">
                        <div className="d-md-flex justify-content-between mb-16">
                            {
                                isCurated() ? (
                                    <div className="description">
                                        {
                                            this.props.labels?.curated_paths_description
                                                ? (
                                                    <div dangerouslySetInnerHTML={{__html: this.props.labels?.curated_paths_description}} />
                                                ) : (
                                                    <>
                                                        <p>
                                                            <strong>Select one of the highlighted jobs to see a curated path to get there.</strong>
                                                        </p>
                                                        <p>
                                                            Explore jobs in detail and access to our online learning material to gain the
                                                            required
                                                            skills and move to the next level.
                                                        </p>
                                                    </>
                                                )
                                        }

                                    </div>
                                ) : (
                                    <div className="description">
                                        <p>
                                            <strong>{headline}</strong>
                                        </p>
                                        <p>{subHeadline}</p>
                                    </div>
                                )
                            }


                            <div
                                className="d-md-flex flex-column align-items-md-end"
                                style={{
                                    visibility: isCurated() ? 'hidden' : 'visible',
                                }}
                            >
                                <div className="search-jobs">
                                    <form action="/">
                                        <label htmlFor="search" className="show-for-sr">
                                            Search jobs
                                        </label>
                                        <input
                                            type="search"
                                            placeholder={this.props.labels?.search_jobs_placeholder || 'Search jobs…'}
                                            onChange={this.onSearch}
                                            id="search"
                                            value={searchValue}
                                        />

                                        <div style={{
                                            visibility: searchValue ? 'visible' : 'hidden'
                                        }}>
                                            {
                                                countOfHighlightedElements ? (
                                                    <a
                                                        href="#careerMap"
                                                        onClick={scrollToAnchor}
                                                        className="search-jobs__count"
                                                    >
                                                        {countOfHighlightedElements === 1 ? `${countOfHighlightedElements} result found` : `${countOfHighlightedElements} results found`}
                                                    </a>
                                                ) : (
                                                    <span className="search-jobs__count">
                                                        {countOfHighlightedElements === 1 ? `${countOfHighlightedElements} result found` : `${countOfHighlightedElements} results found`}
                                                    </span>
                                                )
                                            }
                                        </div>

                                        <button type="submit">
                                            <span className="show-for-sr">Search</span>
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>

                        <div className="d-flex flex-column flex-md-row justify-content-between gap-4">
                            <div className="d-flex align-items-center stats">
                                <a href="#learning-path" className="button-related-path" onClick={scrollToAnchor}>{this.props.labels?.related_path_btn || 'See related learning path below'}</a>

                                {
                                    isCurated() ? (
                                        <div className="stats__count">{countOfSelectedJobs ? '1 Curated Path selected' : '0 Curated Paths selected'} </div>
                                    ) : (
                                        <div className="stats__count">{countOfSelectedJobs} {countOfSelectedJobs === 1 ? 'Job' : 'Jobs'} selected</div>
                                    )
                                }
                            </div>

                            {
                                enableSemiconductorDisclaimer && semiconductorToggleLabel ? (
                                    <div className="d-flex align-items-center toggle">
                                        <label className="toggle-button" htmlFor="semiconductor-toggle">
                                            {semiconductorToggleLabel}
                                            <input
                                                type="checkbox"
                                                id="semiconductor-toggle"
                                                name="enable-semiconductor"
                                                onChange={toggleSemiconductorJobs}
                                            />
                                            <span></span>
                                        </label>
                                    </div>
                                ) : null
                            }

                            <div className="d-flex align-items-center reset">
                                <button className="reset__button" onClick={reset}>{this.props.labels?.clear_map_btn || 'Clear Map'}</button>
                            </div>
                        </div>

                        {
                            !isIncludeGetStartedSection && isShowRegions && regions && regions.length > 0 ? (
                                <div className="regions-wrapper">
                                    <span className="regions-title">{this.props.labels?.regions_title || 'View job information for:'}</span>

                                    <ul className="regions-list" role="listbox" aria-label="Regions">
                                        {
                                            regions.map((region, index) => (
                                                <li className="regions-list__item" key={index}>
                                                    <input
                                                        type="radio"
                                                        className="regions-list__radio"
                                                        name="region"
                                                        id={`region-${index}`}
                                                        value={region.id}
                                                        checked={selectedRegion === region.id}
                                                        onChange={() => setRegion(region.id)}
                                                    />
                                                    <label className="regions-list__label" htmlFor={`region-${index}`}>{region.name}</label>
                                                </li>
                                            ))
                                        }
                                    </ul>
                                </div>
                            ) : null

                        }

                        {
                            ( disclaimer === '' || disclaimer === 'both' || disclaimer === 'college' ) && disclaimerPosition === 'top' && (
                                <div className="d-flex justify-content-end">
                                    <ul className="map-legends">
                                        <li className="map-legends__item">
                                            <span className="map-legends__icon"><span className="diamond-icon"/></span>
                                            <span className="map-legends__name">{disclaimerCollegeText || '4-year College Degree is Typically Required'}</span>
                                        </li>
                                    </ul>
                                </div>
                            )
                        }

                        {
                            ( ( disclaimer === 'union' || disclaimer === 'both' ) && disclaimerPosition === 'top' ) && (
                                <div className="d-flex justify-content-end">
                                    <ul className="map-legends">
                                        <li className="map-legends__item">
                                            <span className="map-legends__icon"><span className="union-icon"/></span>
                                            <span className="map-legends__name">{disclaimerUnionText || 'Union Membership is Common for This Position'}</span>
                                        </li>
                                    </ul>
                                </div>
                            )
                        }

                        {
                            (highlightDemandJobs && highDemandText && disclaimerPosition === 'top') && (
                                <div className="d-flex justify-content-end">
                                    <div class="high-demand-disclaimer"><span></span>{highDemandText || ''}</div>
                                </div>
                            )
                        }

                    </div>
                </header>
                {
                    ReactDOM.createPortal(
                        <div
                            className="modal-outer-wrapper"
                            id="aboutModal"
                            style={{
                                '--h': 0,
                                '--s': '0%',
                                '--l': '65%',
                            }}
                        >
                            <div className="modal-inner-wrapper d-table">
                                <div className="d-table-cell">
                                    <div className="modal">
                                        <header className="modal-header">
                                            <div className="container">
                                                <button className="modal-close js-modal-close">
                                                    <span className="show-for-sr">Close modal</span>
                                                </button>

                                                <h2 className="modal-job-name">{this.props.labels?.about_map_btn || 'About this Map / FAQs'}</h2>
                                            </div>
                                        </header>

                                        <div className="modal-body">
                                            <div className="modal-top">
                                                <div className="container" >
                                                    <div className="modal-description" dangerouslySetInnerHTML={{__html: aboutThisMap}} />
                                                </div>
                                            </div>

                                            <div className="modal-bottom">
                                                <div className="container"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>,
                        document.querySelector('body')
                    )
                }
            </>
        );
    }
}

Header.propTypes = {
    reset: PropTypes.func.isRequired,
    setCurated: PropTypes.func.isRequired,
    showCuratedJobs: PropTypes.func.isRequired,
    mapNode: PropTypes.func.isRequired,
    mapName: PropTypes.string.isRequired,
    isMixpanel: PropTypes.bool.isRequired,
    curatedJobs: PropTypes.array.isRequired,
    headline: PropTypes.string.isRequired,
    subHeadline: PropTypes.string.isRequired,
    disclaimer: PropTypes.string.isRequired,
    disclaimerPosition: PropTypes.string.isRequired
};
